import {useContext} from 'react'

import { ShowDocumentPersonalizadoModalFormWrapper } from './ShowDocumentModalPersonalizadoFormWrapper'
import { ShowDocumentPersonalizadoModalHeader } from './ShowDocumentPersonalizadoModalHeader'
import { PartnerContext } from '../PartnerContexts'

const ShowDocumentPersonalizadoModal = () => {

  const {showSelectDocumentPersonalizadoModal} = useContext(PartnerContext)

  return (
    <>
      {showSelectDocumentPersonalizadoModal && (
        <>
          <div>
            <div className='modal fade show d-block' role='dialog' tabIndex={-1} aria-modal='true'>
              {/* begin::Modal dialog */}
              <div className='modal-dialog modal-dialog-centered modal-xl'>
                {/* begin::Modal content */}
                <div className='modal-content'>
                  <ShowDocumentPersonalizadoModalHeader />
                  {/* begin::Modal body */}
                  <div className='modal-body scroll-y mx-5 mx-xl-5 my-2'>
                    <ShowDocumentPersonalizadoModalFormWrapper />
                  </div>
                  {/* end::Modal body */}
                </div>
                {/* end::Modal content */}
              </div>
              {/* end::Modal dialog */}
            </div>
          </div>
          {/* begin::Modal Backdrop */}
          <div className='modal-backdrop fade show'></div>
          {/* end::Modal Backdrop */}
        </>
      )}
    </>
  )
}

export {ShowDocumentPersonalizadoModal}
